// extracted by mini-css-extract-plugin
export default {"noAmountCheckBox":"NoAmountCheckbox_noAmountCheckBox__juUI3"};